import styled from 'styled-components';

export const List = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  width: 100%;
`;

export const Title = styled.div`
  padding: 0.5rem 0.5rem;
  color: #495057;
  font-size: 1rem;
  font-weight: 500;
  border-bottom: 2px solid #ddff00;
`;
